import React from "react";

import { ReactComponent as IconInstagram } from "../../assets/icons/icon_instagram.svg";
import { ReactComponent as IconLinkedin } from "../../assets/icons/icon_linkedin.svg";
import { ReactComponent as IconTelegram } from "../../assets/icons/icon_telegram.svg";
import { ReactComponent as IconYoutube } from "../../assets/icons/icon_youtube.svg";
import logo_footer from "../../assets/images/logo_footer.png";
import logo_footer2 from "../../assets/images/logo_footer2.png";
import socialLinks, { SocialLinkConfig } from "../../config/socialLinks";
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  BlockSection,
  BottomMetaSection,
  BottomSection,
  ButtonContainer,
  ButtonsSection,
  Contacts,
  Container,
  Copyright,
  FooterWrapper,
  InfoSection,
  LegalInfo,
  LinksBlock,
  Logo,
  LogoSection,
  NavigationSection,
  PolicyInfo,
  SectionTitle,
  SocialLink,
  SocialLinks,
  StyledLink,
} from "./styles";

const socialIcons = {
  instagram: IconInstagram,
  youtube: IconYoutube,
  linkedin: IconLinkedin,
  telegram: IconTelegram,
} satisfies Record<SocialLinkConfig["id"], React.ComponentType<React.SVGProps<SVGSVGElement>>>;

type FooterProps = {
  isCLevelPage?: boolean;
};

export const Footer = ({
  isCLevelPage = false
}: FooterProps) => {
  const footerLogo = isCLevelPage ? logo_footer2 : logo_footer;

  return (
    <FooterWrapper $isDarkTheme={isCLevelPage}>
      <Container $isDarkTheme={isCLevelPage}>
        <LogoSection>
          <Logo src={footerLogo} />
        </LogoSection>
        <InfoSection>
          <LegalInfo $isDarkTheme={isCLevelPage}>
            ИП Прохорова Любовь Васильевна <br/>
            Адрес: Россия, г. Краснодар, ул. Яна Полуяна 42<br />
            ОГРНИП: 321237500416095, ИНН: 231130103902
          </LegalInfo>
          <ButtonsSection>
            <ButtonContainer $isDarkTheme={isCLevelPage}>
              <ButtonAnchor
                href="https://t.me/ProhorovaConsult"
                title="Задать вопрос"
                bgColor="#BFDCF5"
              />
              <ButtonAnchor
                href="https://t.me/+pWQsax6E5mY2OGVi"
                title="Обсуждение ЗП в ИТ/Диджитал"
              />
            </ButtonContainer>
          </ButtonsSection>
        </InfoSection>
        <NavigationSection>
          <LinksBlock>
            <BlockSection>
              <SectionTitle $isDarkTheme={isCLevelPage}>Консалтинг</SectionTitle>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/c-level">Продвижение ТОП–менеджеров</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/search-support">Пакетное сопровождение</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/probation-support">Сопровождение испытательного срока</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/cv-ready">Резюме под ключ</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/vacancies">Месячная подписка на поиск вакансий</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/linkedin-boost">Развитие Linkedin профиля</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/career-consult">Карьерная консультация</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/talkitout">Сессия «Выговориться»</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/career-audit">Карьерный аудит 360</StyledLink>
            </BlockSection>
            <BlockSection>
              <SectionTitle $isDarkTheme={isCLevelPage}>Компания</SectionTitle>
              <StyledLink $isDarkTheme={isCLevelPage} to="/company">О нас</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/it-hiring">ИТ Подбор</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/services/it-training">Обучение</StyledLink>
              <StyledLink $isDarkTheme={isCLevelPage} to="/blog">Блог</StyledLink>
              <PolicyInfo $isDarkTheme={isCLevelPage} to="/policy">Политика конфиденциальности</PolicyInfo>
            </BlockSection>
          </LinksBlock>
        </NavigationSection>
        <BottomSection>
          <Contacts $isDarkTheme={isCLevelPage}>
            Часы работы: пн-пт, с 9:00 до 18:00&emsp;Контакты: prohorovaconsult@yandex.ru
          </Contacts>
          <BottomMetaSection>
            <Copyright $isDarkTheme={isCLevelPage}>Copyright © ProhorovaConsult</Copyright>
            <SocialLinks>
              {[...socialLinks]
                .sort((firstLink, secondLink) => firstLink.order - secondLink.order)
                .map(({ id, href, label, ariaLabel }) => {
                  const Icon = socialIcons[id];

                  return (
                    <SocialLink
                      $isDarkTheme={isCLevelPage}
                      key={id}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={ariaLabel ?? label}
                      title={label}
                    >
                      <Icon />
                    </SocialLink>
                  );
                })}
            </SocialLinks>
          </BottomMetaSection>
        </BottomSection>
      </Container>
    </FooterWrapper>
  );
};
